import { Atom, Coins } from "lucide-react";
import { Link } from "react-router";

import CoachingAssetMobile from "@/../../hypetrain/static/img/exec-home/asset-coaching-mobile.png";
import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";
import { BaseLottieAnimation } from "@/components/pieces/animations/BaseLottieAnimation";
import { Button } from "@/components/ui/button";

export function CoachingCallout() {
  return (
    <div className="relative w-full overflow-hidden rounded-3xl bg-yellow-50">
      {/* Background image - hidden on mobile, visible on md+ */}
      <div
        className="absolute right-0 z-0 hidden h-full w-full max-w-sm md:block lg:max-w-lg xl:max-w-xl"
        style={{ overflow: "hidden" }}
      >
        <div
          className="h-full w-full"
          style={{ display: "flex", alignItems: "stretch", height: "100%" }}
        >
          <BaseLottieAnimation animationUrl="https://placement-pub.s3.us-east-2.amazonaws.com/coaching.json" />
        </div>
      </div>

      {/* Mobile image at the top - only visible on small screens */}
      <div className="relative max-h-48 w-full overflow-hidden md:hidden">
        <EmbedSvg
          src={CoachingAssetMobile}
          alt="Coaching Network"
          className="w-full"
        />
      </div>

      {/* Content container - full width on mobile, 2/3 width on md+ */}
      <div className="flex w-full flex-col gap-6 px-6 py-9 md:w-2/3 md:gap-12 md:p-12 lg:p-16">
        <div className="max-w-2xl">
          <div className="mb-4 text-lg font-semibold text-yellow-700 md:text-2xl">
            1:1 Coaching
          </div>

          <div className="text-2xl/snug font-semibold text-gray-800 md:text-3xl/snug">
            Deploy custom coaching programs supported by vetted coaches with
            domain expertise
          </div>
        </div>
        <div className="flex flex-col gap-6 md:flex-row">
          <div className="flex flex-1 items-center gap-6 md:flex-col md:items-start">
            <div className="rounded-lg bg-yellow-100 p-2">
              <Atom className="text-yellow-700" size={36} strokeWidth={1} />
            </div>
            <div className="text-gray-800">
              Give your people access to a network of top 2% coaches (we've
              vetted over 20,000) to support customized coaching programs.
            </div>
          </div>

          <div className="flex flex-1 items-center gap-6 md:flex-col md:items-start">
            <div className="rounded-lg bg-yellow-100 p-2">
              <Coins className="text-yellow-700" size={36} strokeWidth={1} />
            </div>
            <p className="text-gray-800">
              Only pay for the coaching your employees need with credit-based
              pricing and no annual contracts or per-employee fees.
            </p>
          </div>
        </div>
        <div className="mt-6 md:mt-0">
          <Button
            intent="secondary"
            variant="outline"
            className="bg-transparent px-8 font-semibold"
            asChild
          >
            <Link to="/coaching-platform">Learn More</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
